define('lq/services/application/applicationValidation',[],function () {
    'use strict';
    
    // todo svb SPA this is a placeholder for the integration with new Runtime validator

    function ApplicationValidation() {
    };

    ApplicationValidation.typeName = 'ApplicationValidation';

    ApplicationValidation.prototype.initialize = function () {
        
    };
    
    return ApplicationValidation;
});
